<script lang="ts">
  import { is } from '@shared/utils';

  type Breakpoint = 'sm' | 'md' | 'lg';
  export let classes = '';
  export let breakpoints: Breakpoint[] | undefined = undefined;
</script>

<!--use negative margins to compensate parent main container paddings-->
<div
  class="{is(
    breakpoints !== undefined && breakpoints.includes('sm'),
    '-mx-5 md:mx-0',
    '-mx-5 overflow-hidden md:-mx-8 xl:-mx-12',
  )} {classes}"
>
  <slot />
</div>
